<template>
  <div class="modal-overlay">
    <div
      ref="kt_modal_consulta_avancada_consultar"
      data-bs-backdrop="static"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_consulta_avancada_consultar"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-body p-0">
            <div class="card">
              <div class="card-header">
                <div class="card-title d-flex align-items-center">
                  <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                    <inline-svg src="media/icons/duotune/general/gen002.svg" />
                  </span>
                  <h3 class="fw-bold m-0 text-gray-800">Consulta Avançada</h3>
                </div>
                <div
                  class="btn btn-icon btn-sm btn-active-light-primary mt-6"
                  data-bs-dismiss="modal"
                  @click="this.$emit('exibirModalConsultaAvancada', false)"
                >
                  <span class="svg-icon svg-icon-1 svg-icon lh-0">
                    <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                  </span>
                </div>
              </div>
              <div class="card-body p-0">
                <div
                  v-if="this.errosValidacaoGeral.length"
                  class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
                >
                  <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                    <inline-svg src="media/icons/duotune/general/gen044.svg" />
                  </span>
                  <div class="d-flex flex-stack flex-grow-1">
                    <div class="fw-bold">
                      <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                      <div class="fs-6 text-gray-600">
                        <ul>
                          <li
                            v-for="value in this.errosValidacaoGeral"
                            :key="value"
                          >
                            {{ value }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-header border-0 pt-5">
                  <div class="card-title">
                    <div
                      class="d-flex align-items-center position-relative my-1"
                    >
                      <span class="svg-icon svg-icon-1 position-absolute ms-6">
                        <inline-svg
                          src="media/icons/duotune/general/gen004.svg"
                        />
                      </span>
                      <input
                        id="txtPesquisarConsultaAvancada"
                        v-model="tableData.search"
                        @input="onSearch($event.target.value)"
                        class="form-control form-control-solid w-250px ps-15"
                        placeholder="Pesquisar filtro"
                        @keydown="keydownPesquisa"
                        autocomplete="off"
                        type="search"
                      />
                    </div>
                  </div>
                  <div class="card-toolbar">
                    <div
                      v-if="checkedConsultaAvancada.length > 0"
                      class="d-flex justify-content-end align-items-center"
                      data-kt-customer-table-toolbar="selected"
                    >
                      <div class="fw-bolder me-5">
                        <span class="me-2">{{
                          checkedConsultaAvancada.length
                        }}</span
                        >Selecionado(s)
                      </div>
                      <button
                        v-if="this.excluir"
                        type="button"
                        class="btn btn-sm btn-danger"
                        @click="deleteSelecionados()"
                      >
                        Excluír Selecionado(s)
                      </button>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-0">
                  <component
                    :is="modalComponent"
                    ref="table"
                    :table-header="tableHeader"
                    :table-data="tableData"
                    :table-pagination="tablePagination"
                    :page-sizes="pageSizes"
                    :enable-items-per-page-dropdown="true"
                    :hide-on-single-page="false"
                    empty-table-text="Nenhum filtro encontrado"
                    v-on:checked-rows="checkedConsultaAvancada = $event"
                    v-on:double-click="selecionarRegistro($event)"
                    v-on:current-row-selected="currentRow = $event"
                    :current-row="currentRow"
                  >
                    <template v-slot:cell-checkbox="{ row: consultaAvancada }">
                      <div
                        class="form-check form-check-sm form-check-custom form-check-solid"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :value="consultaAvancada.id"
                          v-model="checkedConsultaAvancada"
                        />
                      </div>
                    </template>
                    <template v-slot:cell-id="{ row: consultaAvancada }">
                      {{ consultaAvancada.id }}
                    </template>
                    <template v-slot:cell-descricao="{ row: consultaAvancada }">
                      {{ consultaAvancada.descricao }}
                    </template>
                    <template v-slot:cell-acoes="{ row: consultaAvancada }">
                      <div class="min-w-200px">
                        <button
                          type="button"
                          class="btn btn-sm btn-light btn-light-primary me-2"
                          @click="selecionarRegistro(consultaAvancada)"
                        >
                          Selecionar
                        </button>
                        <button
                          class="btn btn-sm btn-light btn-active-light-primary"
                          data-kt-menu-trigger="click"
                          data-kt-menu-placement="bottom-end"
                          data-kt-menu-flip="top-end"
                        >
                          Ações
                          <span class="svg-icon svg-icon-5 m-0">
                            <inline-svg
                              src="media/icons/duotune/arrows/arr072.svg"
                            />
                          </span>
                        </button>
                        <div
                          v-if="this.editar || this.excluir"
                          class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                          data-kt-menu="true"
                        >
                          <div v-if="this.editar" class="menu-item px-3">
                            <a
                              @click="editarConsultaAvancada(consultaAvancada)"
                              class="menu-link px-3"
                              >Editar</a
                            >
                          </div>
                          <div v-if="this.excluir" class="menu-item px-3">
                            <a
                              @click="removerRegistro(consultaAvancada.id)"
                              class="menu-link px-3"
                              >Excluír</a
                            >
                          </div>
                        </div>
                      </div>
                    </template>
                  </component>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalConsultaAvancada'"
    mensagem=""
    v-if="this.loading === true"
  ></LoadingModal>
  <EditarDescricaoFiltroModal
    v-if="exibirEditarDescricaoFiltro"
    :consultaAvancada="this.consultaAvancada"
    @exibirModalEditarDescricaoFiltro="modalEditarDescricaoFiltro"
    @confirmarEditarDescricaoFiltro="confirmarEditarDescricaoFiltro"
  ></EditarDescricaoFiltroModal>
</template>

<script>
import { markRaw } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import EditarDescricaoFiltroModal from "@/components/query-builder/EditarDescricaoFiltroModal.vue";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
import {
  hideModal,
  hideModalId,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";

export default {
  emits: ["exibirModalConsultaAvancada", "selecionarConsultaAvancada"],
  props: {
    tabela: { type: String, required: true },
  },
  components: {
    EditarDescricaoFiltroModal,
    LoadingModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    loadData() {
      this.tableData.search = "";
      this.tablePagination.page = 1;
      this.tablePagination.rowsPerPage = 10;
      this.$refs.table.setRowsPage(10);
      this.tableData.filterOData = "";
      this.$refs.table.load();
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=tabela eq '" +
          this.tabela +
          "' and ( contains(descricao, '" +
          pesquisa +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData + " or id eq " + pesquisa + " )";
        } else {
          this.tableData.filterOData = this.tableData.filterOData + " )";
        }
      } else {
        this.tableData.filterOData = "&$filter=tabela eq '" + this.tabela + "'";
      }
    },
    async deleteSelecionados() {
      var alert = await Swal.fire({
        text: "Deseja remover os registros selecionados?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.table.setLoading(true);
        for (var i = 0; i < this.checkedConsultaAvancada.length; i++) {
          await this.excluirConsultaAvancada(this.checkedConsultaAvancada[i]);
        }
        if (this.excluiuCadastro === true) {
          toast.success("Filtros excluídos com sucesso!", { timeout: 3000 });
        }
        this.$refs.table.load();
      }
    },
    async removerRegistro(id) {
      var alert = await Swal.fire({
        text: "Deseja remover o registro?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.table.setLoading(true);
        await this.excluirConsultaAvancada(id);
        if (this.excluiuCadastro === true) {
          toast.success("Filtro excluído com sucesso!", { timeout: 3000 });
        }
        this.$refs.table.load();
      }
    },
    async excluirConsultaAvancada(id) {
      try {
        await this.$store.dispatch(
          "consultaAvancada/deleteConsultaAvancada",
          id
        );
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    async selecionarRegistro(consulta) {
      consulta = await this.getConsultaAvancada(consulta.id);
      this.$emit("selecionarConsultaAvancada", consulta);
      hideModalId("kt_modal_consulta_avancada_consultar");
      this.$emit("exibirModalConsultaAvancada", false);
    },
    async getConsultaAvancada(id) {
      try {
        var ret = await this.$store.dispatch(
          "consultaAvancada/getConsultaAvancada",
          id
        );
        if (ret.Success === true) {
          return ret.Data;
        }
      } catch (error) {
        console.log(error);
      }
      return null;
    },
    async editarConsultaAvancada(consulta) {
      this.consultaAvancada = await this.getConsultaAvancada(consulta.id);
      if (this.consultaAvancada != null) {
        this.modalEditarDescricaoFiltro(true);
      }
    },
    modalEditarDescricaoFiltro(exibir) {
      this.exibirEditarDescricaoFiltro = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_editar_descricao_filtro");
        }, 100);
      }
    },
    async confirmarEditarDescricaoFiltro(consulta) {
      this.consultaAvancada = consulta;
      this.errosValidacao = [];
      await this.exibirModalLoading(true);
      try {
        var retPut = await this.$store.dispatch(
          "consultaAvancada/putConsultaAvancada",
          this.consultaAvancada
        );
        if (retPut.Success === true) {
          this.$refs.table.load();
          await this.exibirModalLoading(false);
          await this.showSuccessAlert(retPut.Message);
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        this.errosValidacao = error;
        console.log(error);
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loading = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingModalConsultaAvancada");
      } else {
        await this.sleep(500);
        hideModalId("loadingModalConsultaAvancada");
        await this.sleep(100);
        this.loading = false;
      }
    },
    async showSuccessAlert(text) {
      await Swal.fire({
        text: text,
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-success",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      } else if (event.key === "Escape") {
        const cancelButton = document.querySelector(".swal2-cancel");
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.ConsultaAvancada.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.ConsultaAvancada.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
    async keydownPesquisa(e) {
      if (e.key === "ArrowUp") {
        e.preventDefault();
        this.currentRow -= 1;
        if (this.currentRow < 0) {
          this.currentRow = 0;
        }
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "ArrowDown") {
        e.preventDefault();
        this.currentRow += 1;
        this.$refs.table.setCurrentRow(this.currentRow);
      } else if (e.key === "Enter") {
        e.preventDefault();
        let consulta = this.$refs.table.getCurrentItemIndex(this.currentRow);
        this.selecionarRegistro(consulta);
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    import("@/components/kt-datatable/KTDatatableCustom.vue").then((module) => {
      this.modalComponent = markRaw(module.default);
    });
    setTimeout(() => {
      this.nextFocus("txtPesquisarConsultaAvancada");
    }, 800);
  },
  data() {
    return {
      currentRow: 0,
      modalComponent: null,
      timeOut: null,
      loading: false,
      exibirEditarDescricaoFiltro: false,
      exibirEditarConsultaAvancada: false,
      consultaAvancada: null,
      adicionar: false,
      editar: false,
      excluir: false,
      checkedConsultaAvancada: [],
      errosValidacaoGeral: [],
      errosValidacao: {},
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "ID",
          key: "id",
          sortable: true,
        },
        {
          name: "Descrição",
          key: "descricao",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "consultaAvancada/getConsultaAvancadaOData",
        selectOData: "?$select=id,descricao",
        filterOData: "&$filter=tabela eq '" + this.tabela + "'",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
